import { palette } from '@core/theme/units/palette';

import { createTheme } from './createTheme';

export const muiTheme = createTheme({
  palette: palette,
});
